<template>
  <b-row>
    <b-col cols="12">
      <role-content />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import RoleContent from './RoleContent.vue'

export default {
  components: {
    BRow,
    BCol,

    RoleContent
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>